export const TRACKING_ELEMENT_NAME = {
    BRAND: 'name',
    SLOGAN: 'slogan',
};
